import { api } from "@/api";
import { AxiosResponse } from "axios";
class API {
  static getMiniExtract(): Promise<AxiosResponse> {
    return api.get("/exclusive-club/summary");
  }
  static getAbout(): Promise<AxiosResponse> {
    return api.get("/exclusive-club/about");
  }
  static getSurveyMonkey(payload: any): Promise<AxiosResponse> {
    return api.get("/exclusive-club/surveys", { params: payload.params });
  }
}

export default API;
